/**
 * The product's name, in one place.
 *
 * The workspace was originally called "Content Operations Workspace" and its
 * header read "Content Ops". The product is now "Content Planner", but the name
 * had been copied into the shell, the landing page, the user guide, and the
 * document title independently, so renaming it meant finding every literal.
 *
 * Display copy composes these constants. Repository identifiers deliberately do
 * NOT: `apps/content-operations-workspace`, the `@odc/content-operations-workspace`
 * package, and the `odc-content-operations-workspace-us` Pages project keep their
 * original names. See the naming decision in AGENTS.md.
 */
export const productName = "Content Planner";

export const productOwner = "Ohdelices";

/** Generic first-party copy is used before an agency branding context exists. */
export const productFullName = productName;
